import { Trans } from "@lingui/macro";
import { dataArrayUnique, testAppendAttr } from "@smp/utils";
import format from "date-fns/format";
import parseISO from "date-fns/parseISO";
import { useMemo } from "react";

import { useDialog } from "@/hooks/use_dialog";
import { useEpPageconfigListRecursive } from "@/hooks/use_ep_pageconfig";
import { useContextApp } from "@/screens/app/context/app";

import { HeaderButton } from "../../shared";
import { DialogWorld } from "./dialog_world";

export const World = () => {
  const {
    state: { plansubscriptionActive, plansubscriptionLast, planLast },
  } = useContextApp();

  const {
    close: dialogClose,
    isOpen: isDialogOpen,
    open: dialogOpen,
  } = useDialog();

  const { isPageconfigListLoading, pageconfigList } =
    useEpPageconfigListRecursive({
      req: {
        query: { all_organization_contexts: "True", has_scheduled_posts: true },
      },
    });

  const pagesUsed = useMemo(
    () =>
      pageconfigList
        ? dataArrayUnique(
            pageconfigList.map(
              (pageconfig) => `${pageconfig.medium}:${pageconfig.external_id}`,
            ),
          ).length
        : 0,
    [pageconfigList],
  );

  if (isPageconfigListLoading) {
    return null;
  }

  if (!pageconfigList) {
    return null;
  }

  const pagesLimit = planLast ? planLast.social_pages_limit : 0;

  const isExpired = !!plansubscriptionLast && !plansubscriptionActive;

  return (
    <>
      <HeaderButton
        captionLeft={
          !!plansubscriptionLast && !!plansubscriptionActive ? (
            <>
              <Trans>until</Trans>{" "}
              {format(parseISO(plansubscriptionLast.period_end), "dd.MM.yyyy")}
            </>
          ) : undefined
        }
        onClick={dialogOpen}
        isExpired={isExpired}
        textLeft={
          !plansubscriptionLast ? (
            <Trans>Not selected</Trans>
          ) : !!plansubscriptionActive ? (
            <span
              style={{ display: "block", fontSize: 16, lineHeight: "16px" }}
            >
              {pagesUsed} <Trans>of</Trans> {pagesLimit}
            </span>
          ) : (
            <Trans>Expired</Trans>
          )
        }
        {...testAppendAttr("id", `header_billing_world`)}
      />

      {isDialogOpen && (
        <DialogWorld
          onClose={dialogClose}
          pagesLimit={pagesLimit}
          pagesUsed={pagesUsed}
        />
      )}
    </>
  );
};
